module.exports = __webpack_public_path__ + "static/img/blog-img1.6a3ea07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-img1.jpg
// module id = C2W3
// module chunks = 1